import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import EmptyDataMessage from './EmptyDataMessage.component';
import { DetailConf } from '../../../module/yachtDashboard/conf/attendance/Detail.conf';
import { DashboardDetail } from '../../detail/DashboardDetail';

const AttendanceTabContent = ({ attendances }) => {
  const { fields, formatValue } = DetailConf;
  const colorTab = '#bbdefb';

  return (
    <Box sx={{ minHeight: '55vh' }}>
      {!_.isEmpty(attendances) ? (
        attendances.map((attendance) => {
          const agentNA = _.get(
            attendance,
            'attributes.id_agent_NA.data.attributes.id_users_permissions_user.data'
          );
          return (
            <Link
              to={`/attendances/${attendance?.id}`}
              key={attendance?.id}
              style={{ textDecoration: 'none' }}
            >
              <DashboardDetail
                fields={fields}
                data={attendance}
                render={formatValue}
                colorTab={colorTab}
                hasHeader={!_.isEmpty(agentNA)}
              />
            </Link>
          );
        })
      ) : (
        <EmptyDataMessage message='No attendances found' />
      )}
    </Box>
  );
};

export default AttendanceTabContent;
